<template>
	<div>
		<div v-if="!loaded" class="flex center text-center mb-1">
			<i class="fas fa-cog fa-spin fa-2x"></i>
			Loading....
		</div>

		<!--		ARTICLE-->
		<div v-if="loaded && type === 'article'">
			<form class="list-filter list-filter--article" method="get" ref="filterForm" @submit.prevent>
				<div class="form-group">
					<label for="limit"><i class="fas fa-fw fa-list-ul"></i> Show</label>
					<select id="limit" name="limit" v-model="selectedLimit" @change="changeLimit">
						<option value="25">25</option>
						<option value="50">50</option>
						<option value="100">100</option>
						<option value="9999999">All</option>
					</select>
				</div>

				<div class="form-group">
					<label for="status"><i class="fas fa-fw fa-traffic-light"></i> Status</label>
					<select id="status" v-model="filterStatus" @change="filter">
						<option :value="null">All</option>
						<option :value="status.toLowerCase()" v-for="(status,index) in data.statuses">{{ status }}</option>
						<option :value="'inUse'">In Use</option>
					</select>
				</div>

				<div class="form-group">
					<label for="author"><i class="fas fa-fw fa-user"></i> Author</label>
					<select id="author" v-model="filterAuthor" @change="filter">
						<option value="null">All</option>
						<option :value="author.user_id" v-for="author in data.authors">{{ author.full_name }}</option>
					</select>
				</div>

				<div class="form-group">
					<label for="category"><i class="fas fa-fw fa-archive"></i> Category</label>
					<select id="category" v-model="filterCategory" @change="filter">
						<option value="null">All</option>
						<option :value="category.id" v-for="category in data.categories">{{ category.title }}</option>
					</select>
				</div>

				<div class="form-group">
					<label for="inContent"><i class="fas fa-fw fa-list-ul"></i> Content?</label>
					<select id="inContent" name="limit" v-model="filterInContent" @change="filter">
						<option :value="true">Yes</option>
						<option :value="false">No</option>
					</select>
				</div>

				<div class="form-group">
					<label for="filter"><i class="fas fa-fw fa-filter"></i> Filter</label>
					<div class="input-group">
						<input id="filter" class="input-small" name="filter" type="text" :placeholder="'Filter in ' + filterInFields.join(', ') " v-model="filterString" @keyup="filter(false)" @keydown.enter="filter(true)">
						<button class="btn btn-primary" :disabled="!filterInContent" @click="filter(true)">Filter</button>
					</div>
				</div>
			</form>
			<slot name="content" :list="processedList" :authors="data.authors" :categories="data.categories"></slot>
			<ul role="navigation" class="pagination">
				<li class="page-item" :class="[paginator.currentPage === 1 ? 'disabled '  : ' ']">
					<a v-if="paginator.currentPage > 1" @click="previousPage" class="page-link">‹</a>
					<span v-else class="page-link">‹</span>
				</li>
				<li class="page-item" v-for="pageNumber in paginator.pages" :class="[pageNumber === paginator.currentPage ? 'active '  : ' ']">
					<span v-if="paginator.currentPage > 3 && pageNumber === 2" class="page-link">...</span>

					<span v-if="paginator.currentPage < paginator.maxPage - 3 && pageNumber === paginator.maxPage - 1" class="page-link">...</span>

					<span v-if="pageNumber === paginator.currentPage" class="page-link">{{ pageNumber }}</span>
					<a v-else-if="pageNumber === 1 || pageNumber === paginator.currentPage + 1 || pageNumber === paginator.currentPage + 2 || pageNumber === paginator.currentPage - 1 || pageNumber === paginator.maxPage" @click="gotoPage(pageNumber)" class="page-link">{{ pageNumber }}</a>
				</li>
				<li class="page-item" :class="[paginator.currentPage === paginator.maxPage ? 'disabled '  : ' ']">
					<a v-if="paginator.currentPage < paginator.maxPage" @click="nextPage" class="page-link">›</a>
					<span v-else class="page-link">›</span>
				</li>
			</ul>
		</div>
		<!--		ARTICLE-->

		<!--		GENERAL-->
		<div v-if="loaded && type === 'general'">
			<header class="page-title">
				<slot name="header" :title="data.title"></slot>
			</header>
			<form class="list-filter flex box" method="get" ref="filterForm" @submit.prevent>
				<div class="two form-group">
					<label for="limit"><i class="fas fa-fw fa-list-ul"></i> Show</label>
					<select id="limit" name="limit" v-model="selectedLimit" @change="changeLimit">
						<option value="25">25</option>
						<option value="50">50</option>
						<option value="100">100</option>
						<option value="9999999">All</option>
					</select>
				</div>
				<slot v-if="hasAdditionalFilters">
					<div :class="numbersInString[filter.width] +' form-group'" v-for="(filter,name) in additionalFilters">
						<label :for="'additional-' + name"><i class="fas fa-fw fa-list-ul"></i> {{ name }}</label>
						<select :id="'additional-' + name" :name="'additional-' + name" v-model="selectedAdditionalFilters[name]" @change="additionalFilter(name)">
							<option v-for="item in filter.elements" :value="filter.elementsValue !== null ? item[filter.elementsValue] : item">{{ filter.elementsLabel !== null ? item[filter.elementsLabel] : item }}</option>
							<option :value="null">All</option>
						</select>
					</div>
				</slot>


				<div :class="numbersInString[mainFilterWidth] +' form-group'">
					<label for="filter"><i class="fas fa-fw fa-filter"></i> Filter</label>
					<div class="input-group">
						<input id="filter" class="input-small" name="filter" type="text" :placeholder="'Filter in ' + filterInFields.join(', ') " v-model="filterString" @keyup="filter" @keydown.enter.prevent>
						<button class="btn btn-primary" :disabled="!this.filterEnabled">Filter</button>
					</div>
				</div>
			</form>
			<slot name="content" :list="processedList" :rawData="data"></slot>
			<ul role="navigation" class="pagination" v-if="paginator.maxPage > 1">
				<li class="page-item" :class="[paginator.currentPage === 1 ? 'disabled '  : ' ']">
					<a v-if="paginator.currentPage > 1" @click="previousPage" class="page-link">‹</a>
					<span v-else class="page-link">‹</span>
				</li>
				<li class="page-item" v-for="pageNumber in paginator.pages" :class="[pageNumber === paginator.currentPage ? 'active '  : ' ']">
					<span v-if="paginator.currentPage > 3 && pageNumber === 2" class="page-link">...</span>

					<span v-if="paginator.currentPage < paginator.maxPage - 3 && pageNumber === paginator.maxPage - 1" class="page-link">...</span>

					<span v-if="pageNumber === paginator.currentPage" class="page-link">{{ pageNumber }}</span>
					<a v-else-if="pageNumber === 1 || pageNumber === paginator.currentPage + 1 || pageNumber === paginator.currentPage + 2 || pageNumber === paginator.currentPage - 1 || pageNumber === paginator.maxPage" @click="gotoPage(pageNumber)" class="page-link">{{ pageNumber }}</a>
				</li>
				<li class="page-item" :class="[paginator.currentPage === paginator.maxPage ? 'disabled '  : ' ']">
					<a v-if="paginator.currentPage < paginator.maxPage" @click="nextPage" class="page-link">›</a>
					<span v-else class="page-link">›</span>
				</li>
			</ul>
		</div>
		<!--		GENERAL-->
		<loader></loader>
	</div>
</template>

<script>
import {eventBus} from '../app'

export default {
	props: {
		apiUrl: {
			type: String
		},
		listInData: {
			type: String
		},
		filterIn: {
			type: Array
		},
		listType: {
			type: String
		},
		orderBy: {
			type: Array
		},
		orderByRules: {
			type: Array
		},
		showOnly: {
			type: Object
		},
		limit: {
			type: String
		},
		additionalFilters: {
			type: Object
		}
	},
	data() {
		return {
			type: typeof this.listType !== 'undefined' ? this.listType : 'general',

			loaded: false,
			filterString: '',
			filterEnabled: true,
			processedList: [],

			paginator: {},
			title: '',
			data: [],

			allProviders: {},
			selectedLimit: typeof this.limit !== 'undefined' ? this.limit === 'all' ? 9999999 : parseInt(this.limit) : 25,
			startIndex: 0,
			endIndex: 24,

			userRoles: this.$currentUserRoles,

			forceUpdater: 0,
			filterAuthor: null,
			filterStatus: null,
			filterCategory: null,
			filterInContent: false,
			contentFilter: null,

			filterInFields: this.filterIn,

			availableParameters: ['query', 'author', 'status', 'category'],
			mainFilterWidth: 10,
			numbersInString: ['null', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'ten'],

			hasAdditionalFilters: false,
			selectedAdditionalFilters: {},
		}
	},
	watch: {
		filterInContent: function (newQuestion, oldQuestion) {
			if (newQuestion === false && oldQuestion === true) {
				this.fetchDataFromApi();
			}
		}
	},
	computed: {
		filteredList: function () {
			this.forceUpdater;
			if (typeof this.data[this.listInData] === 'undefined') {
				return [];
			}
			let vm = this;
			let filtered = [];
			if (this.filterString === '') {
				filtered = JSON.parse(JSON.stringify(this.data[this.listInData]));
			} else {
				let list = JSON.parse(JSON.stringify(this.data[this.listInData]));
				list.forEach((element, index) => {
					this.filterInFields.some((field, index) => {
						if ((this.filterString.length > 0 && typeof element[field] !== 'undefined' && (element[field].toString().toLowerCase().includes(this.filterString.toLowerCase())))) {
							filtered.push(element);
							return true;
						}
					});
				});
			}


			if (this.type === 'article') {
				let keepIndexes = Array.from(filtered.keys());
				if (this.filterAuthor !== null && this.filterAuthor !== 'null') {
					let keepIndexesByAuthor = [];
					filtered.forEach((element, index) => {
						if (element.author_id === vm.filterAuthor) {
							keepIndexesByAuthor.push(index);
						}
					});
					keepIndexes = keepIndexes.filter(x => keepIndexesByAuthor.includes(x));
				}

				if (this.filterStatus !== null && this.filterStatus !== 'null') {
					let keepIndexesByStatus = [];
					filtered.forEach((element, index) => {
						if (vm.filterStatus === 'inUse' && element.inUse === true) {
							keepIndexesByStatus.push(index);
						}
					});
					keepIndexes = keepIndexes.filter(x => keepIndexesByStatus.includes(x));
				}

				if (this.filterCategory !== null && this.filterCategory !== 'null') {
					let keepIndexesByCategory = [];
					filtered.forEach((element, index) => {
						if (element.category === vm.filterCategory) {
							keepIndexesByCategory.push(index);
						}
					});
					keepIndexes = keepIndexes.filter(x => keepIndexesByCategory.includes(x));
				}

				let filteredArticles = [];
				filtered.forEach((element, index) => {
					if (keepIndexes.includes(index)) {
						filteredArticles.push(element);
					}
				});

				filtered = filteredArticles;
			}

			if (this.hasAdditionalFilters === true) {
				let vm = this;
				let additionalFiltered = [];
				let haveWeFiltered = false;
				Object.keys(this.additionalFilters).forEach(function (index) {

							if (vm.additionalFilters[index].filterIn !== null && vm.selectedAdditionalFilters[index] !== vm.additionalFilters[index].default) {
								haveWeFiltered = true;
								filtered.forEach(function (entry) {
									if (entry[vm.additionalFilters[index].filterIn] === vm.selectedAdditionalFilters[index]) {
										additionalFiltered.push(entry);
									}
								});
							}
						}
				);
				if (haveWeFiltered === true) {
					filtered = additionalFiltered;
				}
			}

			if (typeof this.showOnly !== 'undefined' && Object.keys(this.showOnly).length > 0) {
				let vm = this;
				let filteredShowOnly = [];
				Object.keys(this.showOnly).forEach(function (key) {
					filtered.forEach(function (entry) {

						if (typeof vm.showOnly[key] === 'object' && vm.showOnly[key].constructor === Object) {
							let matchCounter = 0;
							Object.keys(vm.showOnly[key]).forEach(function (filterKey) {
								let actualFilter = vm.showOnly[key][filterKey];

								if (actualFilter[0] === '=' && entry[filterKey] === actualFilter[1]) {
									matchCounter++;
								}
								if (actualFilter[0] === '!=' && entry[filterKey] !== actualFilter[1]) {
									matchCounter++;
								}
								if (actualFilter[0] === '>' && entry[filterKey] > actualFilter[1]) {
									matchCounter++;
								}
								if (actualFilter[0] === '<' && entry[filterKey] < actualFilter[1]) {
									matchCounter++;
								}
								if (actualFilter[0] === '>=' && entry[filterKey] >= actualFilter[1]) {
									matchCounter++;
								}
								if (actualFilter[0] === '<=' && entry[filterKey] <= actualFilter[1]) {
									matchCounter++;
								}
							});
							if (matchCounter === Object.keys(vm.showOnly[key]).length) {
								filteredShowOnly.push(entry);
							}

						} else {
							/*
							for simple filtering:
									showOnly: {
										tier: 'tier1',
									},
							*/
							if (vm.showOnly[key].substring(0, 2) === '!=' && entry[key] !== vm.showOnly[key].substring(2)) {
								filteredShowOnly.push(entry);
							} else if (entry[key] === vm.showOnly[key]) {
								filteredShowOnly.push(entry);
							}
						}
					});
				});
				filtered = filteredShowOnly;
			}

			if (typeof this.orderBy !== 'undefined' && typeof this.orderByRules !== 'undefined') {
				filtered = _.orderBy(filtered, this.orderBy, this.orderByRules);
			}

			this.initPaginate(filtered);
			return filtered;
		}
	},
	created() {
		this.generateAdditionalFilters();
		this.fetchDataFromApi(true);
		let page = 1;

		let vm = this;
		eventBus.$on('listRenderer-fetch', function (options = null) {
			eventBus.$emit('onLoaderStart');
			if (options !== null) {
				if (options.hasOwnProperty('apiUrl')) {
					vm.apiUrl = options.apiUrl;
				}
				if (options.hasOwnProperty('listInData')) {
					vm.listInData = options.listInData;
				}
				if (options.hasOwnProperty('filterInFields')) {
					vm.filterInFields = options.filterInFields;
				}
				if (options.hasOwnProperty('keepPage')) {
					page = vm.paginator.currentPage;
				}
			}
			vm.fetchDataFromApi(true, page);
		});
	},
	methods: {

		generateAdditionalFilters: function () {
			if (typeof this.additionalFilters !== 'undefined' && Object.keys(this.additionalFilters).length > 0) {
				this.hasAdditionalFilters = true;
				let vm = this;
				Object.keys(this.additionalFilters).forEach(function (index) {
					if (vm.additionalFilters[index].hasOwnProperty('orderBy') && vm.additionalFilters[index].hasOwnProperty('orderByRules')) {
						vm.additionalFilters[index].elements = _.orderBy(vm.additionalFilters[index].elements, vm.additionalFilters[index].orderBy, vm.additionalFilters[index].orderByRules);
					}
					vm.mainFilterWidth -= vm.additionalFilters[index].width;
					vm.selectedAdditionalFilters[index] = vm.additionalFilters[index].default;
				});
			}
		},

		fetchDataFromApi: function (init = false, page = 1) {
			let vm = this;
			axios.post(vm.apiUrl, {
				tab: vm.tabName,
				filterInContent: vm.filterInContent,
				filterAuthor: vm.filterAuthor,
				filterStatus: vm.filterStatus,
				filterCategory: vm.filterCategory,
				filterString: vm.filterString,
			})
					.then(response => {
						if (response.data.hasOwnProperty('data')) {
							eventBus.$emit('listRendererData', response.data.data);
							vm.data = response.data.data;
						}
						vm.initPaginate(vm.data[vm.listInData]);
						if (vm.contentFilter !== vm.filterString) {
							vm.contentFilter = vm.filterString;
							if (init !== true) {
								vm.filter();
							}
						}
						if (init === true) {
							vm.loadParameters();
						}
						if (page === 1) {
							vm.changePage();
						} else {
							vm.gotoPage(page);
						}
						eventBus.$emit('onLoaderFinish');
					})
					.catch(e => {
						vm.$toastr.error('Api in ListRenderer failed', 'Error');
						eventBus.$emit('onLoaderFinish');
					});
		},
		filter: function (button) {
			if (this.filterInContent === true && !this.filterInFields.includes('content')) {
				this.filterInFields.push('content');
			}
			if (this.filterInContent === false) {
				let filtered = this.filterInFields.filter(function (item) {
					return item !== 'content';
				});
				this.filterInFields = filtered;
			}
			if (this.filterInContent === true && button === false) {
				return true;
			}
			if (this.filterInContent === true && this.contentFilter !== this.filterString) {
				this.fetchDataFromApi();
				return true;
			}
			this.updateUrl();
			this.initPaginate(this.filteredList);
			this.changePage();
		},
		additionalFilter: function (name) {
			this.forceUpdate();
			if (name !== null) {
				this.updateUrl();
				eventBus.$emit('additionalFilterChange', name, this.additionalFilters[name], this.selectedAdditionalFilters[name]);
			}
			this.reRender();
		},
		reRender: function () {
			this.changePage();
		},
		initPaginate: function (list) {
			if (typeof list === 'object' && typeof list !== 'undefined') {
				this.paginator = {
					currentPage: 1,
					maxPage: Math.ceil(list.length / parseInt(this.selectedLimit))
				};
				this.paginator.pages = [];
				for (let i = 1; i <= this.paginator.maxPage; i++) {
					this.paginator.pages.push(i);
				}
				this.loaded = true;
			}
			this.$forceUpdate();
		},
		nextPage: function () {
			this.paginator.currentPage++;
			if (this.paginator.currentPage > this.paginator.maxPage) {
				this.paginator.currentPage = this.paginator.maxPage;
			}
			this.changePage();
		},
		previousPage: function () {
			this.paginator.currentPage--;
			if (this.currentPage < 1) {
				this.currentPage = 1;
			}
			this.changePage();
		},
		gotoPage: function (index) {
			this.paginator.currentPage = index;
			this.changePage();
		},
		changePage: function () {
			this.startIndex = (this.paginator.currentPage - 1) * parseInt(this.selectedLimit);
			this.endIndex = this.startIndex + parseInt(this.selectedLimit);
			this.processedList = this.filteredList.slice(this.startIndex, this.endIndex);
		},
		changeLimit: function () {
			this.initPaginate(this.filteredList);
			this.changePage();
		},
		forceUpdate: function () {
			this.forceUpdater++;
		},
		loadParameters: function () {
			let vm = this;
			this.availableParameters.forEach((parameter) => {
				let check = vm.getParameterByName(parameter);
				if (check !== null) {
					if (parameter === 'query') {
						vm.filterString = check;
					}
					if (parameter === 'category') {
						vm.filterCategory = parseInt(check);
					}
					if (parameter === 'author') {
						vm.filterAuthor = parseInt(check);
					}
					if (parameter === 'status') {
						vm.filterStatus = check;
					}
				}
			});
			if (this.hasAdditionalFilters === true) {
				Object.keys(this.additionalFilters).forEach(function (index) {
					let check = vm.getParameterByName('additional_' + index);
					if (check === 'false') {
						check = false;
					}
					if (check === 'true') {
						check = true;
					}
					if (check !== null) {
						vm.selectedAdditionalFilters[index] = check;
						eventBus.$emit('additionalFilterChange', index, vm.additionalFilters[index], vm.selectedAdditionalFilters[index]);
					}
				});
			}
			this.filter();
			this.additionalFilter(null);
		},
		getParameterByName: function (name, url) {
			if (!url) url = window.location.href;
			name = name.replace(/[\[\]]/g, '\\$&');
			let regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
					results = regex.exec(url);
			if (!results) return null;
			if (!results[2]) return '';
			return decodeURIComponent(results[2].replace(/\+/g, ' '));
		},
		updateUrl: function (clean = false) {
			let newurl = window.location.protocol + "//" + window.location.host + window.location.pathname;
			let parameters = [];
			if (this.filterString !== null && this.filterString !== '') {
				parameters.push('query=' + this.filterString);
			}
			if (this.filterAuthor !== null && this.filterAuthor !== 'null') {
				parameters.push('author=' + this.filterAuthor);
			}
			if (this.filterCategory !== null && this.filterCategory !== 'null') {
				parameters.push('category=' + this.filterCategory);
			}
			if (this.filterStatus !== null && this.filterStatus !== 'null') {
				parameters.push('status=' + this.filterStatus);
			}
			if (this.getParameterByName('tab') !== null) {
				parameters.push('tab=' + this.getParameterByName('tab'));
			}

			if (this.hasAdditionalFilters === true) {
				let vm = this;
				Object.keys(this.additionalFilters).forEach(function (index) {
					if (vm.selectedAdditionalFilters[index] !== null) {
						parameters.push('additional_' + index + '=' + vm.selectedAdditionalFilters[index]);
					}
				});
			}

			if (parameters.length > 0) {
				parameters = parameters.join('&');
				newurl += '?' + parameters;
			}
			window.history.pushState({path: newurl}, '', newurl);
		},
	}
}
</script>

<style scoped>

</style>
